import Axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const unAuthorized = () => {
	localStorage.removeItem('token');
    localStorage.removeItem('refresh');
    localStorage.removeItem('user_full_name');
    localStorage.removeItem('user_type');
	
	window.location = '/login';
};

const notFoundPage = () => {
	// window.location = '/404';
};

const errorHandler = (statusCode, message) => {
	switch (statusCode) {
		case 401:
			// unAuthorized();
			break;
		case 404:
			notFoundPage();
			break;
		default:
			break;
	}
};

const instance = Axios.create({
	baseURL: API_URL,
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
});

instance.interceptors.request.use(function (config) {
	const token = localStorage.getItem('token');
	if (token) config.headers.Authorization = 'Bearer ' + token;

	return config;
});

instance.interceptors.response.use(
	(response) => {
		return response;
	},
	async (err) => {
		errorHandler(err?.response?.status);
		return Promise.reject(err);
		// if (err.response.status === 401) {
		//   const originalConfig = err.config;
		//   if (originalConfig.url !== "user/auth/token" && err.response) {
		//     // Access Token was expired
		//     if (!originalConfig._retry) {
		//       originalConfig._retry = true;

		//       try {
		//         const refreshToken = localStorage.getItem('refresh');
		//         console.log('Going to rs');
		//         const rs = await instance.post("user/auth/token/refresh", { refresh_token: refreshToken });
		//         console.log('rs', rs);
		//         if (rs.status === 401) {
		//           errorHandler(err?.response?.status);
		//           return Promise.reject(err);
		//         } else {
		//           const { accessToken } = rs.data;
		//           localStorage.setItem('token', accessToken);

		//           return instance(originalConfig);
		//         }
		//       } catch (_error) {
		//         return Promise.reject(_error);
		//       }
		//     }
		//   }
		// } else {
		//   errorHandler(err?.response?.status);
		// }

		// return Promise.reject(err);
	},
);

export default instance;
